module.exports = __webpack_public_path__ + "img/woman-book.3124d5d4.png";